import axios from 'axios'
import JWT from "@/utils/jwt"
import { APP_CONFIG } from '@/utils/constants'
import router from "@/router";

const validStatuses = [
  200, 201, 202, 203, 204,
  300, 301, 302, 303, 304
]

axios.defaults = {
  baseURL: APP_CONFIG.apiUrl,
  headers: {
    'Content-Type': 'application/json'
  },
	withCredentials: false,
	credentials: 'include',
	crossDomain: true,
}

axios.interceptors.request.use(
  async (config) => {
    const accessToken = JWT.getAccessToken()
    
    if (accessToken) {
      config.headers['Authorization'] = 'Bearer ' + accessToken
    }
    
    return config
  },
  error => {
    Promise.reject(error)
  }
)

axios.interceptors.response.use((response) => {
  return response
}, function (error) {
  const originalRequest = error.config

  if (error.response.status === 401 && originalRequest.url == `${APP_CONFIG.apiUrl}/auth/login`) {
    return Promise.reject(error)
  }

  if (error.response.status === 401 && originalRequest.url == `${APP_CONFIG.apiUrl}/auth/token-refresh`) {
    JWT.destroyToken()
    router.push({ name: 'auth-login' })
    return Promise.reject(error)
  }

  if (error.response.status === 500 && originalRequest.url == `${APP_CONFIG.apiUrl}/auth/token-refresh`) {
    JWT.destroyToken()
    router.push({ name: 'auth-login' })
    return Promise.reject(error.message)
  }

  if (error.response.status === 401 && !originalRequest._retry) {
    originalRequest._retry = true;
    const refreshToken = JWT.getRefreshToken()

    return axios.post(`${APP_CONFIG.apiUrl}/auth/token-refresh`, {
          token: `${refreshToken}`
        },
        {
          withCredentials: false,
          crossDomain: true
        }
      )
      .then((res) => {
        // if (res.status === 200)
        JWT.setAccessToken(res.data.access_token, res.data.expire_at)

        axios.defaults.headers = {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + res.data.access_token
        }

        return axios(originalRequest)
      })
  }
  return Promise.reject(error)
})

export function checkResponse(response) {
  if (validStatuses.includes(response.status)) {
    return response
  }
  
  if (response.status === 401) {
    JWT.destroyToken()
    return Promise.reject(new Error('USER_ANONYMOUS'))
  }

  let err = new Error(response.statusText)
  err.response = response

  return Promise.reject(err)
}

export function processAPIErrors(apiErrors) {
  let errors = {}

  if (apiErrors) {
    for (let key of Object.keys(apiErrors)) {
      let err = apiErrors[key]

      errors[key] = err

      if (typeof err === Object || err.hasOwnProperty('length')) {
        errors[key] = apiErrors[key][0]
      }
    }
  }

  return errors
}

export const esc = encodeURIComponent

export function qs(params) {
  return (
    Object
    .keys(params)
    .map(k => esc(k) + '=' + esc(params[k]))
    .join('&')
  )
}

export function postToken(uri, data) {
  return axios.post(uri, data, {
    headers: {
      'Token': `${JWT.getRefreshToken()}`,
    },
    withCredentials: false,
    crossDomain: true
  })
}

export function post(uri, data) {
  return axios.post(uri, data, {
    withCredentials: false,
    crossDomain: true
  })
}

export function put(uri, data) {
  return axios.put(uri, data, {
    withCredentials: false,
    crossDomain: true
  })
}

export function remove(uri) {
  return axios.delete(uri, {
    withCredentials: false,
    crossDomain: true
  })
}

export function get(uri, data = {}) {
  if (Object.keys(data).length > 0) {
    uri = `${uri}?${qs(data)}`
  }

  return axios.get(uri, {
    withCredentials: false,
    crossDomain: true
  })
}

export function upload(uri, data) {
  return fetch(uri, {
    // headers: getHeaders(true),
    // cors: true,
    method: 'PUT',
    body: data
  })
}

// // Means endpoint
// export function e(uri) {
//   return BASE_URL + uri
// }